import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Container} from '../ui';
import * as Actions from 'actions';
import {SidebarLeft, DeleteAllClients} from 'components';
import {FormBuilder} from '../form-builder';
import { Link } from 'react-router';
import * as Permissions from 'permissions';

class ClientsSettingsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formSettings : [
        { iconClass : 'fa fa-indent', path : '/clients/settings/fields', label : 'Custom Fields'},
        { iconClass : 'fa fa-sort-alpha-asc', path : '/clients/settings/types', label : 'Custom Types'},
      ],
      pipelineSettings : [
        { iconClass : 'fa fa-flag-checkered', path : '/clients/settings/pipeline-builder', label : 'Pipeline Builder'}
      ]
    }
  }

  render() {
    return <Container title="Client Settings">
      <SidebarLeft title="Options" fixed={true}>
        <div className="widget-header clearfix">
          <h6 className="title pull-left mt-xs">Form Settings</h6>
        </div>
        <div className="widget-content">
          <ul className="list-unstlyed mg-folders">
             {this.state.formSettings.map((item, idx) => {
              return (
                <li key={idx}>
                  <Link activeClassName="nav-active" className="menu-item" to={item.path}>
                    <i className={item.iconClass}></i> {item.label}
                  </Link>
                </li>
              )
             })}
          </ul>
        </div>
        <div className="widget-header clearfix">
          <h6 className="title pull-left mt-xs">Pipeline Settings</h6>
        </div>
        <div className="widget-content">
          <ul className="list-unstlyed mg-folders">
             {this.state.pipelineSettings.map((item, idx) => {
              return (
                <li key={idx}>
                  <Link activeClassName="nav-active" className="menu-item" to={item.path}>
                    <i className={item.iconClass}></i> {item.label}
                  </Link>
                </li>
              )
             })}
          </ul>
        </div>
        {this.props.hasPermission(Permissions.DELETE_CLIENTS) ? <div>
          <hr className="text-dark dotted" />
          <DeleteAllClients />
        </div>: ''}
      </SidebarLeft>
      {this.props.children}
    </Container>
  }
}

const mapStateToProps = ({connection}) => ({user:connection.user});

export default connect(mapStateToProps,Actions)(ClientsSettingsView);



// WEBPACK FOOTER //
// ./src/browser/components/clients/clients-settings-view.js